import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import MagicLinkLogin from '~/components/auth/MagicLinkLogin'
import LoginCodeForm from '~/components/auth/LoginCodeForm'
import Spacer from '~/components/Spacer'
import Center from '~/components/basic/Center'

const SwitchLink = styled.button`
  display: inline;
  border: none;
  background: none;
  padding: 0;
  font-size: 0.85em;
  color: #8a8a8a;
  cursor: pointer;
  font-family: ${(props) => props.theme.fonts.avenirNextRegular};
  text-decoration: none;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
`

@inject((all) => ({ auth: all.store.auth }))
@observer
class PasswordlessLogin extends Component {
  state = {
    showCodeForm: false,
  }

  showCodeForm = () => {
    this.setState({ showCodeForm: true })
  }

  showMagicLinkForm = () => {
    // Reset sent state so MagicLinkLogin shows the email form, not the success message
    this.props.auth.changeKey('magicLinkEmailSent', false)
    this.setState({ showCodeForm: false })
  }

  render() {
    const { showCodeForm } = this.state

    if (showCodeForm) {
      return (
        <>
          <LoginCodeForm />
          <Spacer mobile={10} desktop={10} />
          <Center>
            <SwitchLink type="button" onClick={this.showMagicLinkForm}>
              Email me a login link instead
            </SwitchLink>
          </Center>
        </>
      )
    }

    return (
      <MagicLinkLogin onShowCodeForm={this.showCodeForm} />
    )
  }
}

export default PasswordlessLogin
